/**
 * Created by staffanrantzow on 14/06/16.
 */

const REGULAR_TYPE_ID = 1;

class SalaryEntity {

  constructor (
    id,
    allowance,
    categoryId,
    typeId,
    createdAt,
    grossAmount,
    grossOld,
    invoiceId,
    netAmount,
    paidAt,
    paymentStatus,
    plannedPaymentAt,
    resentStatus,
    taxAmount,
    taxkeyId,
    toPay,
    travel,
    userId,
    companyName,
    specificationPdfUrl,
    invoice,
    invoiceDates,
    taxAgencySalary
  ) {
    this.id = id;
    this.allowance = allowance;
    this.categoryId = categoryId;
    this.typeId = parseInt(typeId);
    this.createdAt = createdAt;
    this.grossAmount = grossAmount;
    this.grossOld = grossOld;
    this.invoiceId = invoiceId;
    this.netAmount = netAmount;
    this.paidAt = paidAt;
    this.paymentStatus = paymentStatus;
    this.plannedPaymentAt = plannedPaymentAt;
    this.resentStatus = resentStatus;
    this.taxAmount = taxAmount;
    this.taxkeyId = taxkeyId;
    this.toPay = toPay;
    this.travel = travel;
    this.userId = userId;
    this.companyName = companyName;
    this.specificationPdfUrl = specificationPdfUrl;
    this.invoice = invoice;
    this.invoiceDates = invoiceDates;
    this.taxAgencySalary = taxAgencySalary;
  }

  isRegular () {
    return this.typeId === REGULAR_TYPE_ID;
  }

  taxAgencyPart (attribute) {
    if (this.taxAgencySalary) {
      return parseFloat(this.taxAgencySalary.attributes[attribute]);
    }

    return 0;
  }

  grossIncTaxAgencyPart () {
    return this.grossAmount + this.taxAgencyPart('gross_amount');
  }

  netIncTaxAgencyPart () {
    return this.netAmount + this.taxAgencyPart('net_amount');
  }

  toPayIncTaxAgencyPart () {
    return this.toPay + this.taxAgencyPart('to_pay');
  }
}

export default SalaryEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/salaries/salary-entity.js
 **/